'use client';

import { Localite } from '@/payload-types';
import { LocalityProvider } from '@/providers/Locality';
import { LocalityModel } from '@/types/LocalityModel';
import LocalityBreadcrumbs from './LocalityBreadcrumb';
import LocalitesPage from './LocalitesPage';
import { NearbyLocalites } from './NearbyLocalites';

export type LocalitySectionProps = {
  slug: string | undefined;
  localite: LocalityModel | undefined;
  breadcrumbs: Localite['breadcrumbs'];
  layout: Localite['layout'];
  urlSlug: string[] | undefined;
  nearbyLocalites: LocalityModel[];
};

/** Sous-arbre complet des routes /localites. Tous ces composants sont clients. */
export default function LocalitySectionInner({
  slug,
  localite,
  breadcrumbs,
  layout,
  urlSlug,
  nearbyLocalites,
}: LocalitySectionProps) {
  return (
    <LocalityProvider slug={slug} localite={localite}>
      <LocalityBreadcrumbs breadcrumbs={breadcrumbs} />
      {urlSlug && <LocalitesPage page={layout} slug={urlSlug} />}
      <NearbyLocalites nearby={nearbyLocalites} />
    </LocalityProvider>
  );
}
